import classNames from 'classnames';
import React from 'react';

import styles from './Button.module.css';

type ButtonProps = React.HTMLAttributes<HTMLButtonElement> & {
  size?: 'medium' | 'large';
  color?: 'brand' | 'primary' | 'secondary';
  variant?: 'contained' | 'outlined' | 'text';
  fullWidth?: boolean;
};

export default function Button(props: ButtonProps) {
  const {
    size = 'medium',
    color = 'primary',
    variant = 'contained',
    fullWidth = false,
    className,
    children,
    ...rest
  } = props;

  let styleClass = `button--${color}`;
  const sizeClass = `button--size-${size}`;

  if (variant === 'outlined') {
    styleClass = `${styleClass}--outline`;
  }

  if (variant === 'text') {
    styleClass = `${styleClass}--text`;
  }

  return (
    <button
      className={classNames(
        styles['button'],
        styles[styleClass],
        styles[sizeClass],
        {
          'w-full': fullWidth,
        },
        className,
      )}
      type="button"
      {...rest}
    >
      {children}
    </button>
  );
}
